import React from 'react'

import { useRouter } from 'next/router'

const useSearchParams = () => {
  const router = useRouter()

  return React.useMemo(() => router.query, [router.query])
}

export default useSearchParams
